<div class="app-header">
  <img src="assets/img/logo.png" height="30px">
</div>

<div class="container mt-5">
  <alert *ngIf="sent" type="success">Thank you for accepting the offer. HR has been informed and a Service Agreement
    will be sent to your email.
  </alert>
</div>
